module.exports = __webpack_public_path__ + "img/GlsLogo.e31f3982.png";